/* eslint-disable max-len */
/* eslint-disable no-use-before-define */

import configSystem from '_config';
import { DEFAULT_WIDTH, measureText } from './textMeasure';
import { hyphenateWord } from './hypherUtils';

const ARROW_PATHS = {
  bottom_to_bottom: '<path d="M 30,0 L 30,12" fill="none" stroke="#000" stroke-width="2" /><polygon points="27,9 33,9 30,15" fill="#000" />',
  bottom_to_right: '<path d="M 8,0 L 8,10 L 20,10" fill="none" stroke="#000" stroke-width="2" /><polygon points="17,7 17,13 23,10" fill="#000" />',
  bottom_to_left: '<path d="M 52,0 L 52,10 L 40,10" fill="none" stroke="#000" stroke-width="2" /><polygon points="43,7 43,13 37,10" fill="#000" />',

  right_to_right: '<path d="M 0,30 L 12,30" fill="none" stroke="#000" stroke-width="2" /><polygon points="9,27 9,33 15,30" fill="#000" />',
  right_to_bottom: '<path d="M 0,8 L 10,8 L 10,20" fill="none" stroke="#000" stroke-width="2" /><polygon points="7,17 13,17 10,23" fill="#000" />',
  right_to_top: '<path d="M 0,52 L 10,52 L 10,40" fill="none" stroke="#000" stroke-width="2" /><polygon points="7,43 13,43 10,37" fill="#000" />',

  left_to_left: '<path d="M 60,30 L 48,30" fill="none" stroke="#000" stroke-width="2" /><polygon points="51,27 51,33 45,30" fill="#000" />',
  left_to_bottom: '<path d="M 60,8 L 50,8 L 50,20" fill="none" stroke="#000" stroke-width="2" /><polygon points="47,17 53,17 50,23" fill="#000" />',
  left_to_top: '<path d="M 60,52 L 50,52 L 50,40" fill="none" stroke="#000" stroke-width="2" /><polygon points="47,43 53,43 50,37" fill="#000" />',

  top_to_top: '<path d="M 30,60 L 30,48" fill="none" stroke="#000" stroke-width="2" /><polygon points="27,51 33,51 30,45" fill="#000" />',
  top_to_right: '<path d="M 8,60 L 8,50 L 20,50" fill="none" stroke="#000" stroke-width="2" /><polygon points="17,47 17,53 23,50" fill="#000" />',
  top_to_left: '<path d="M 52,60 L 52,50 L 40,50" fill="none" stroke="#000" stroke-width="2" /><polygon points="43,47 43,53 37,50" fill="#000" />',

  bottom_diagonal_right_to_bottom: '<path d="M 0,0 L 10,10 L 10,20" fill="none" stroke="#000" stroke-width="2" /><polygon points="7,17 13,17 10,23" fill="#000" />',
  bottom_diagonal_right_to_right: '<path d="M 0,0 L 10,10 L 20,10" fill="none" stroke="#000" stroke-width="2" /><polygon points="17,7 17,13 23,10" fill="#000" />',
  bottom_diagonal_left_to_bottom: '<path d="M 60,0 L 50,10 L 50,20" fill="none" stroke="#000" stroke-width="2" /><polygon points="47,17 53,17 50,23" fill="#000" />',
  bottom_diagonal_left_to_left: '<path d="M 60,0 L 50,10 L 40,10" fill="none" stroke="#000" stroke-width="2" /><polygon points="43,7 43,13 37,10" fill="#000" />',
  bottom_diagonal_left_to_top: '<path d="M 60,0 L 50,15 L 50,8" fill="none" stroke="#000" stroke-width="2" /><polygon points="47,11 53,11 50,5" fill="#000" />',
  top_diagonal_right_to_top: '<path d="M 0,60 L 10,50 L 10,40" fill="none" stroke="#000" stroke-width="2" /><polygon points="7,43 13,43 10,37" fill="#000" />',
  top_diagonal_right_to_right: '<path d="M 0,60 L 10,50 L 20,50" fill="none" stroke="#000" stroke-width="2" /><polygon points="17,47 17,53 23,50" fill="#000" />',
  top_diagonal_right_to_bottom: '<path d="M 0,60 L 10,45 L 10,52" fill="none" stroke="#000" stroke-width="2" /><polygon points="7,49 13,49 10,55" fill="#000" />',
  top_diagonal_left_to_top: '<path d="M 60,60 L 50,50 L 50,40" fill="none" stroke="#000" stroke-width="2" /><polygon points="47,43 53,43 50,37" fill="#000" />',
  top_diagonal_left_to_left: '<path d="M 60,60 L 50,50 L 40,50" fill="none" stroke="#000" stroke-width="2" /><polygon points="43,47 43,53 37,50" fill="#000" />',
};

const ARROW_ORIGINS = {
  bottom_to_bottom: { x: 30, y: 0 },
  bottom_to_right: { x: 8, y: 0 },
  bottom_to_left: { x: 52, y: 0 },
  right_to_right: { x: 0, y: 30 },
  right_to_bottom: { x: 0, y: 8 },
  right_to_top: { x: 0, y: 52 },
  left_to_left: { x: 60, y: 30 },
  left_to_bottom: { x: 60, y: 8 },
  left_to_top: { x: 60, y: 52 },
  top_to_top: { x: 30, y: 60 },
  top_to_right: { x: 8, y: 60 },
  top_to_left: { x: 52, y: 60 },
  bottom_diagonal_right_to_bottom: { x: 0, y: 0 },
  bottom_diagonal_right_to_right: { x: 0, y: 0 },
  bottom_diagonal_left_to_bottom: { x: 60, y: 0 },
  bottom_diagonal_left_to_left: { x: 60, y: 0 },
  bottom_diagonal_left_to_top: { x: 60, y: 0 },
  top_diagonal_right_to_top: { x: 0, y: 60 },
  top_diagonal_right_to_right: { x: 0, y: 60 },
  top_diagonal_right_to_bottom: { x: 0, y: 60 },
  top_diagonal_left_to_top: { x: 60, y: 60 },
  top_diagonal_left_to_left: { x: 60, y: 60 },
};

const ARROW_HEADS = {
  bottom_to_bottom: { x: 30, y: 12 },
  bottom_to_right: { x: 20, y: 10 },
  bottom_to_left: { x: 40, y: 10 },
  right_to_right: { x: 12, y: 30 },
  right_to_bottom: { x: 10, y: 20 },
  right_to_top: { x: 10, y: 40 },
  left_to_left: { x: 48, y: 30 },
  left_to_bottom: { x: 50, y: 20 },
  left_to_top: { x: 50, y: 40 },
  top_to_top: { x: 30, y: 48 },
  top_to_right: { x: 20, y: 50 },
  top_to_left: { x: 40, y: 50 },
  bottom_diagonal_right_to_bottom: { x: 10, y: 20 },
  bottom_diagonal_right_to_right: { x: 20, y: 10 },
  bottom_diagonal_left_to_bottom: { x: 50, y: 20 },
  bottom_diagonal_left_to_left: { x: 40, y: 10 },
  bottom_diagonal_left_to_top: { x: 50, y: 8 },
  top_diagonal_right_to_top: { x: 10, y: 40 },
  top_diagonal_right_to_right: { x: 20, y: 50 },
  top_diagonal_right_to_bottom: { x: 10, y: 52 },
  top_diagonal_left_to_top: { x: 50, y: 40 },
  top_diagonal_left_to_left: { x: 40, y: 50 },
};

const POSITION_OFFSETS = {
  bottom: { dx: 0, dy: 1 },
  top: { dx: 0, dy: -1 },
  right: { dx: 1, dy: 0 },
  left: { dx: -1, dy: 0 },
  bottom_diagonal_right: { dx: 1, dy: 1 },
  bottom_diagonal_left: { dx: -1, dy: 1 },
  top_diagonal_right: { dx: 1, dy: -1 },
  top_diagonal_left: { dx: -1, dy: -1 },
};

const DEFAULTS = {
  cellSize: 60,
  padding: 20,
  exportMode: 'combined',
  arrowAlignment: 'default',
  arrowHeadStyle: 'filled',
  borderRadius: 0,
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 9,
  gridColor: '#000000',
  transparentBackground: false,
  bankPosition: 'bottom',
};

function getPositionOffset(posSlug) {
  if (POSITION_OFFSETS[posSlug]) return POSITION_OFFSETS[posSlug];

  const match = Object.keys(POSITION_OFFSETS).find(key => posSlug.includes(key));
  return match ? POSITION_OFFSETS[match] : { dx: 0, dy: 0 };
}

function calcArrowDestination(cell, pos, cellSize) {
  const { dx, dy } = getPositionOffset(pos);
  return {
    x: cell.positionx * cellSize + dx * cellSize,
    y: cell.positiony * cellSize + dy * cellSize,
  };
}

function calcChildYAdjust(pos, offsetY, childH, cellSize) {
  if (childH === null) return 0;
  if (pos.includes('top')) return offsetY;
  if (pos.includes('bottom')) return (offsetY + childH) - cellSize;
  if (pos.includes('left') || pos.includes('right')) return (offsetY + childH / 2) - cellSize / 2;
  return 0;
}

function applyAlignment(arrowKey, pos, align, dest) {
  if (align === 'default' || pos.includes('diagonal')) return dest;

  const origin = ARROW_ORIGINS[arrowKey];
  if (!origin) return dest;

  const alignTargets = { start: 8, center: 30, end: 52 };
  const target = alignTargets[align];
  if (target === undefined) return dest;

  const isVertical = pos === 'bottom' || pos === 'top';
  return isVertical
    ? { x: dest.x + (target - origin.x), y: dest.y }
    : { x: dest.x, y: dest.y + (target - origin.y) };
}

function applyHeadStyle(svgContent, arrowKey, style) {
  if (style === 'default') return svgContent;

  const head = ARROW_HEADS[arrowKey];
  if (!head) return svgContent;

  const base = svgContent.replace(/<polygon[^>]*\/?>/, '');
  const { x: cx, y: cy } = head;

  const styles = {
    filled: `<circle cx="${cx}" cy="${cy}" r="3" fill="#000" />`,
    empty: `<circle cx="${cx}" cy="${cy}" r="2.25" fill="#fff" stroke="#000" stroke-width="1.5" />`,
    dotted: `<circle cx="${cx}" cy="${cy}" r="2.25" fill="#fff" stroke="#000" stroke-width="1.5" /><circle cx="${cx}" cy="${cy}" r="1.2" fill="#000" />`,
  };

  return base + (styles[style] || '');
}

function renderArrow(cell, config, childOffsetY = 0, childHeight = null) {
  const pos = cell.arrow_position && cell.arrow_position.slug;
  const dir = (cell.arrow_direction && cell.arrow_direction.slug) || '';
  if (!pos) return '';

  const arrowKey = `${pos}_to_${dir}`;
  const rawSvg = ARROW_PATHS[arrowKey];
  if (!rawSvg) return '';

  let dest = calcArrowDestination(cell, pos, config.cellSize);
  dest.y += calcChildYAdjust(pos, childOffsetY, childHeight, config.cellSize);
  dest = applyAlignment(arrowKey, pos, config.arrowAlignment, dest);

  if (dest.x < 0 || dest.y < 0) return '';

  const finalSvg = applyHeadStyle(rawSvg, arrowKey, config.arrowHeadStyle);
  return `<g class="arrow-group" data-type="${arrowKey}" transform="translate(${dest.x}, ${dest.y})">${finalSvg}</g>`;
}

function renderCellArrows(cell, config) {
  if (!cell.children || !cell.children.length) return renderArrow(cell, config);

  const { cellSize } = config;
  let svg = '';
  let currentY = 0;

  cell.children.forEach(child => {
    const childH = child.height ? (child.height / 100) * cellSize : cellSize / cell.children.length;
    const adjusted = { ...child, positionx: cell.positionx, positiony: cell.positiony };
    svg += renderArrow(adjusted, config, currentY, childH);
    currentY += childH;
  });

  return svg;
}

function splitIntoLines(text, maxWidthPx, fontSize, locale) {
  const words = text.toString().split(/\s+/);
  const lines = [];
  let current = '';

  words.forEach(word => {
    const combined = current ? `${current} ${word}` : word;

    if (measureText(combined, fontSize) <= maxWidthPx) {
      current = combined;
      return;
    }

    if (current) {
      lines.push(current.trim());
      current = '';
    }

    if (measureText(word, fontSize) > maxWidthPx) {
      const maxChars = Math.max(Math.floor(maxWidthPx / (fontSize * DEFAULT_WIDTH)), 2);
      const parts = hyphenateWord(word, maxChars, locale);
      parts.forEach((part, i) => {
        if (i < parts.length - 1) {
          lines.push(part);
        } else {
          current = part;
        }
      });
      return;
    }

    current = word;
  });

  if (current) lines.push(current.trim());
  return lines;
}

function fitText(text, maxWidth, maxHeight, baseFontSize, locale) {
  const LINE_RATIO = 1.0;
  const MIN_SIZE = 4;
  let size = baseFontSize - 0.5;

  while (size >= MIN_SIZE) {
    const lines = splitIntoLines(text, maxWidth, size, locale);
    const lineH = size * LINE_RATIO;
    const totalH = lines.length * lineH;

    if (totalH <= maxHeight) {
      return { lines, fontSize: size, lineHeight: lineH };
    }

    size -= 0.35;
  }

  return {
    lines: splitIntoLines(text, maxWidth, MIN_SIZE, locale),
    fontSize: MIN_SIZE,
    lineHeight: MIN_SIZE * LINE_RATIO,
  };
}

function renderAnswerText(cell, x, y, w, h, fontFamily) {
  const SIZE = 45;
  return `<text x="${x + w / 2}" y="${y + h / 2 + SIZE * 0.35}" text-anchor="middle" font-size="${SIZE}" font-weight="bold" font-family="${fontFamily}" fill="#000">${cell.text}</text>`;
}

function renderQuestionText(cell, x, y, w, h, config) {
  const SAFE_PAD_X = 4;
  const SAFE_PAD_Y = 2;

  const safeX = x + SAFE_PAD_X;
  const safeY = y + SAFE_PAD_Y;

  const safeW = w - SAFE_PAD_X * 2;
  const safeH = h - SAFE_PAD_Y * 2;

  const {
    lines,
    fontSize,
    lineHeight,
  } = fitText(cell.text, safeW, safeH, config.fontSize, configSystem.LOCALE);

  const totalH = lines.length * lineHeight;
  const startY = safeY + safeH / 2 - totalH / 2 + fontSize * 0.8;
  const centerX = safeX + safeW / 2;

  const tspans = lines
    .map(
      (line, i) => `
        <tspan
          x="${centerX}"
          y="${startY + i * lineHeight}"
        >
          ${line}
        </tspan>
      `,
    )
    .join('');

  return `
    <text
      font-size="${fontSize}"
      font-weight="bold"
      font-family="${config.fontFamily}"
      fill="#000"
      text-anchor="middle"
      dominant-baseline="middle"
      text-rendering="geometricPrecision"
    >
      ${tspans}
    </text>
  `;
}

function shouldShowText(cell, exportMode) {
  if (!cell.text) return false;
  if (cell.isAnswer === true) {
    return exportMode === 'solution' || exportMode === 'combined';
  }

  return exportMode !== 'solution';
}

function renderCellText(cell, x, y, w, h, config) {
  if (!shouldShowText(cell, config.exportMode)) return '';
  return cell.isAnswer
    ? renderAnswerText(cell, x, y, w, h, config.fontFamily)
    : renderQuestionText(cell, x, y, w, h, config);
}

function calcChildHeight(child, parentH, siblingCount) {
  return child.height ? (child.height / 100) * parentH : parentH / siblingCount;
}

function renderChildrenFlat(cell, config, x, y, w, h) {
  let svg = '';
  let currentY = y;

  cell.children.forEach(child => {
    const childH = calcChildHeight(child, h, cell.children.length);
    svg += renderCell(child, config, x, currentY, w, childH);
    currentY += childH;
  });

  return svg;
}

function renderChildrenRounded(cell, config, x, y, w, h, br) {
  const clipId = `clip-${cell.positionx}-${cell.positiony}`;
  const rx = ` rx="${br}" ry="${br}"`;
  const fill = config.transparentBackground ? 'none' : '#ffffff';
  const stroke = config.gridColor;
  const childConfig = { ...config, borderRadius: 0 };
  const count = cell.children.length;

  let svg = `<defs><clipPath id="${clipId}"><rect x="${x}" y="${y}" width="${w}" height="${h}"${rx} /></clipPath></defs>`;
  svg += `<rect x="${x}" y="${y}" width="${w}" height="${h}" fill="${fill}" stroke="${stroke}" stroke-width="1"${rx} />`;
  svg += `<g clip-path="url(#${clipId})">`;

  let currentY = y;
  cell.children.forEach((child, i) => {
    const childH = calcChildHeight(child, h, count);
    svg += renderCell(child, childConfig, x, currentY, w, childH);
    if (i < count - 1) {
      svg += `<line x1="${x}" y1="${currentY + childH}" x2="${x + w}" y2="${currentY + childH}" stroke="${stroke}" stroke-width="1" />`;
    }
    currentY += childH;
  });

  svg += '</g>';
  return svg;
}

function renderCell(cell, config, offsetX = null, offsetY = null, parentW = null, parentH = null) {
  const w = parentW !== null && parentW !== undefined ? parentW : config.cellSize;
  const h = parentH !== null && parentH !== undefined ? parentH : config.cellSize;
  const x = offsetX !== null && offsetX !== undefined ? offsetX : cell.positionx * config.cellSize;
  const y = offsetY !== null && offsetY !== undefined ? offsetY : cell.positiony * config.cellSize;
  const br = config.borderRadius || 0;

  if (cell.children && cell.children.length > 0) {
    return br > 0
      ? renderChildrenRounded(cell, config, x, y, w, h, br)
      : renderChildrenFlat(cell, config, x, y, w, h);
  }

  const fill = config.transparentBackground ? 'none' : '#ffffff';
  const rx = br > 0 ? ` rx="${br}" ry="${br}"` : '';

  let svg = `<rect x="${x}" y="${y}" width="${w}" height="${h}" fill="${fill}" stroke="${config.gridColor}" stroke-width="1"${rx} />`;
  svg += renderCellText(cell, x, y, w, h, config);
  return svg;
}

function renderBankBottom(bank, gridW, gridH, config) {
  const fontSize = 12;
  const charWidth = fontSize * 0.55;
  const paddingRight = 20;
  const spaceAfterBank = 22;
  const startY = gridH;
  const centerY = startY + fontSize + 5;

  let svg = `<text x="0" y="${centerY}" font-family="${config.fontFamily}" font-size="${fontSize}" font-weight="bold" fill="#000" dominant-baseline="central">Banco:</text>`;
  let groupContent = '';
  let currentX = 0;

  bank.forEach(word => {
    const text = `${word.length}/${word}.`;
    const textWidth = text.length * charWidth;

    groupContent += `<text x="${currentX}" y="0" font-family="${config.fontFamily}" font-size="${fontSize}" fill="#000" dominant-baseline="central">${text}</text>`;
    currentX += textWidth + paddingRight;
  });

  const cx = currentX / 2;

  svg += `<g transform="translate(${spaceAfterBank}, ${centerY}) rotate(180, ${cx}, 0)">${groupContent}</g>`;

  return {
    svg: `<g class="svg-bank">${svg}</g>`,
    extraWidth: 0,
    extraHeight: fontSize * 2,
  };
}

function renderBankRight(bank, gridW, gridH, config) {
  const fontSize = 12;
  const charWidth = fontSize * 0.55;
  const paddingRight = 20;
  const spaceAfterBank = 22;
  const gapFromGrid = 8;
  const extraWidth = 20;

  let bankContent = `<text x="0" y="0" font-family="${config.fontFamily}" font-size="${fontSize}" font-weight="bold" fill="#000" dominant-baseline="central">Banco:</text>`;

  let groupContent = '';
  let currentX = 0;

  bank.forEach(word => {
    const text = `${word.length}/${word}.`;
    const textWidth = text.length * charWidth;

    groupContent += `<text x="${currentX}" y="0" font-family="${config.fontFamily}" font-size="${fontSize}" fill="#000" dominant-baseline="central">${text}</text>`;
    currentX += textWidth + paddingRight;
  });

  const cx = currentX / 2;

  bankContent += `<g transform="translate(${spaceAfterBank}, 0) rotate(180, ${cx}, 0)">${groupContent}</g>`;

  const svg = `<g class="svg-bank" transform="translate(${gridW + gapFromGrid}, 0) rotate(90)">${bankContent}</g>`;

  return {
    svg,
    extraWidth,
    extraHeight: 0,
  };
}

function renderBankSVG(bank, gridW, gridH, config) {
  if (config.bankPosition === 'right') {
    return renderBankRight(bank, gridW, gridH, config);
  }
  return renderBankBottom(bank, gridW, gridH, config);
}

function buildConfig(settings) {
  return { ...DEFAULTS, ...settings };
}

export default function generateCrosswordSVG(table, rows, cols, settings = {}) {
  const config = buildConfig(settings);
  const {
    cellSize, padding, gridColor, borderRadius, exportBank, bank,
  } = config;

  const gridW = cols * cellSize;
  const gridH = rows * cellSize;
  const isEnigma = config.exportMode === 'enigma';
  const showArrows = isEnigma || config.exportMode === 'combined';
  const visibleCells = table.filter(c => !c.hide);

  let bankSVG = '';
  let bankExtraWidth = 0;
  let bankExtraHeight = 0;

  if (exportBank && isEnigma && bank && bank.length > 0) {
    const bankData = renderBankSVG(bank, gridW, gridH, config);
    bankSVG = bankData.svg;
    bankExtraWidth = bankData.extraWidth;
    bankExtraHeight = bankData.extraHeight;
  }

  const svgW = gridW + padding * 2 + bankExtraWidth;
  const svgH = gridH + padding * 2 + bankExtraHeight;

  const parts = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${svgW}" height="${svgH}" viewBox="0 0 ${svgW} ${svgH}">`,
    `<g transform="translate(${padding}, ${padding})">`,
  ];

  if (borderRadius === 0) {
    parts.push(`<rect x="0" y="0" width="${gridW}" height="${gridH}" fill="none" stroke="${gridColor}" stroke-width="2" />`);
  }

  parts.push(visibleCells.map(cell => renderCell(cell, config)).join(''));

  if (showArrows) {
    parts.push(visibleCells.map(cell => renderCellArrows(cell, config)).join(''));
  }

  if (bankSVG) {
    parts.push(bankSVG);
  }

  parts.push('</g></svg>');
  return parts.join('');
}
